import { cleanup } from '@testing-library/react';
import { HttpResponse, http } from 'msw';
import { setupServer } from 'msw/node';

import constants from '../constants';
import redux from '../redux';
import translations from '../translations';

translations.init();

describe('customer group selector failure while reading the current context', () => {
  // create a mock server
  const server = setupServer(
    http.get(constants.endpoints.get.context, () => {
      return HttpResponse.json({ status: 500 }, { status: 500 });
    }),
  );

  beforeAll(() => {
    server.listen();
  });

  afterAll(() => {
    server.close();
  });

  afterEach(() => {
    server.resetHandlers();
    cleanup();
  });

  it('should fail to read the current context', async () => {
    redux.store.dispatch(redux.api.getContext());

    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });

    expect(redux.store.getState().api.context).toBeNull();
    expect(redux.store.getState().api.isError).toStrictEqual(true);
  });
});
